import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../auth/useAuth";
import LoginForm, { LoginFormFields } from "./LoginForm";
import useUserInformation from "../../../hooks/useUserInformation";
import { NidessoQueryParams } from "../../../components/router/query-params";
import HalfScreenContainer from "../../../components/HalfScreenContainer";
import { useEffect, useState } from "react";
import { useGlobalState } from "../../../states/global-state/global.state";
import { useQueryClient } from "react-query";
import { isDevelopmentEnv } from "../../../helpers/utils/misc.util";
import classNames from "classnames";

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { getDefaultLink } = useUserInformation();
  const location = useLocation();
  const [error, setError] = useState("");
  const { setIsLoading } = useGlobalState();
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.clear();
  }, [queryClient]);

  const onSubmit = (data: LoginFormFields) => {
    setIsLoading(true);
    login(data.email)
      .then((u) => {
        setError("");
        const locationParam = location.state
          ? location.state[NidessoQueryParams.Location]?.pathname
          : undefined;
        if (locationParam) {
          navigate(locationParam);
        }
        navigate(getDefaultLink(u));
      })
      .catch((error) => {
        setError(
          "Es wurde kein Konto mit den angegebenen Daten gefunden (falsche Email oder Passwort)",
        );
      })
      .finally(() => setIsLoading(false));
  };

  const handleMicrosoftLogin = () => {
    window.location.href = `${process.env.REACT_APP_AUTHORISATION_ENDPOINT}`;
  };

  return (
    <HalfScreenContainer hasNav={false}>
      <HalfScreenContainer.ContentLeft className="flex-col items-center justify-center bg-th-secondary-900">
        <div className="">
          <span className="font-bold uppercase text-white">Login</span>
          <h1 className="text-white">Willkommen zurück!</h1>
        </div>
      </HalfScreenContainer.ContentLeft>

      <HalfScreenContainer.ContentRight className="my-auto space-y-6 p-20 md:p-40">
        <h1 className="text-th-primary-900 lg:hidden">Anmelden</h1>

        {isDevelopmentEnv() && (
          <>
            {/* Login Form */}
            <LoginForm onSubmit={onSubmit} error={error}></LoginForm>

            {/* Divider */}
            <div className="flex items-center justify-center space-x-2">
              <div className="h-px w-1/3 bg-gray-300"></div>
              <span className="text-gray-500">oder</span>
              <div className="h-px w-1/3 bg-gray-300"></div>
            </div>
          </>
        )}

        {/* Login with Microsoft Button */}
        <p
          className={classNames({
            "font-semibold text-gray-500": true,
            "text-center": isDevelopmentEnv(),
          })}
        >
          Logge dich mit deinem Schulkonto bei Nidesso ein.
        </p>
        <button
          onClick={handleMicrosoftLogin}
          className="flex w-full items-center justify-center space-x-2 rounded-lg bg-blue-600 px-4 py-3 font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
            alt="Microsoft Logo"
            className="h-6 w-6"
          />
          <span>Login mit Microsoft</span>
        </button>
      </HalfScreenContainer.ContentRight>
    </HalfScreenContainer>
  );
}

export default Login;
